// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"e4-z"};